var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87 77",
    style: {
      enableBackground: "new 0 0 87 77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#21A366;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#107C41;}\n\t.st2{fill:#33C481;}\n\t.st3{fill:#185C37;}\n\t.st4{fill-opacity:9.411800e-02;}\n\t.st5{fill-opacity:0.2;}\n\t.st6{fill:#107C41;}\n\t.st7{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,2.5H26.5C24.6,2.5,23,4,23,5.9v14.5l30.8,18l15.4,6.5l15.4-6.5v-18L53.8,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,20.5h30.8v18H23V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.2,2.5H53.8v18h30.8V5.9C84.6,4,83.1,2.5,81.2,2.5L81.2,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.8,38.4H23V71c0,1.9,1.5,3.4,3.4,3.4h54.8c1.9,0,3.4-1.5,3.4-3.4V56.4L53.8,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8,38.4h30.8v18H53.8V38.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.3,15.3H23v48.8h22.2c1.9,0,3.4-1.5,3.4-3.4V18.8C48.7,16.9,47.2,15.3,45.3,15.3L45.3,15.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.7,17.9H23v48.8h19.7c1.9,0,3.4-1.5,3.4-3.4V21.3C46.1,19.4,44.6,17.9,42.7,17.9L42.7,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.7,17.9H23v43.6h19.7c1.9,0,3.4-1.5,3.4-3.4V21.3C46.1,19.4,44.6,17.9,42.7,17.9L42.7,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.1,17.9H23v43.6h17.1c1.9,0,3.4-1.5,3.4-3.4V21.3C43.6,19.4,42,17.9,40.1,17.9L40.1,17.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M5.9,17.9h34.2c1.9,0,3.4,1.5,3.4,3.4v34.2c0,1.9-1.5,3.4-3.4,3.4H5.9c-1.9,0-3.4-1.5-3.4-3.4V21.3 C2.5,19.4,4,17.9,5.9,17.9L5.9,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M11.6,51.3l8.3-12.9l-7.6-12.8h6.1l4.2,8.2c0.4,0.8,0.6,1.4,0.8,1.7h0.1c0.3-0.6,0.6-1.2,0.9-1.8l4.4-8.1h5.6 l-7.8,12.7l8,12.9h-6l-4.8-9c-0.2-0.4-0.4-0.8-0.6-1.2h-0.1c-0.1,0.4-0.3,0.8-0.6,1.2l-4.9,9L11.6,51.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExcel);
export default __webpack_public_path__ + "static/media/Logo_Excel.6047733b0c7aefb97420219fce653202.svg";
export { ForwardRef as ReactComponent };